const body = () => {
    return ( 
        <div className="contacts">
            <div class="section contact-info-section section-padding-02">
            <div class="container">
                <div class="contact-info-wrap">
                    <div class="row">
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-contact-info text-center">
                                <div class="info-icon">
                                    <img src="assets/images/info-1.png" alt="" />
                                </div>
                                <div class="info-content">
                                    <h5 class="title">Give us a call</h5>
                                    <a href="tel:+2349038224320"><p>(+234) 903 822 4320</p></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-contact-info text-center">
                                <div class="info-icon">
                                    <img src="assets/images/info-2.png" alt="" />
                                </div>
                                <div class="info-content">
                                    <h5 class="title">Drop us a line</h5>
                                    <a href="mailto:info@themichaelstech.com">
                                    <p>info@themichaelstech.com</p></a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-sm-6">
                            <div class="single-contact-info text-center">
                                <div class="info-icon">
                                    <img src="assets/images/info-3.png" alt="" />
                                </div>
                                <div class="info-content">
                                    <h5 class="title">Visit our office</h5>
                                    <p>Bonny Island, Rivers State, Nigeria</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="section techwix-contact-section techwix-contact-section-02 techwix-contact-section-03 section-padding-02"
        style={{marginBottom: "250px"}}>
            <div class="container">
                <div class="contact-wrap">
                    <div class="row justify-content-center">
                        <div class="col-lg-10">
                            <div class="contact-form">
                                <div class="contact-form-wrap">
                                    <div class="heading-wrap text-center">
                                        <span class="sub-title"> request a quote</span>
                                        <h3 class="title">How May We Help You!</h3>
                                    </div>
                                    <form action="#">
                                        <div class="row">
                                            <div class="col-sm-6">
                                                <div class="single-form">
                                                    <input type="text" placeholder="Name *" />
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="single-form">
                                                    <input type="email" placeholder="Email *" />
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="single-form">
                                                    <input type="text" placeholder="Subject *" />
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="single-form">
                                                    <textarea placeholder="Write A Message"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="form-btn">
                                                    <button class="btn" type="submit">Send Message</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
     );
}
 
export default body;